import AppRouterLink from './AppRouterLink.vue';

export default AppRouterLink;



// WEBPACK FOOTER //
// ./src/uikit/links/AppRouterLink/index.ts